import { baseService } from '@repo/services';
import { type CamelToSnakeCaseKeys, transformGraphqlResponse } from '@repo/utils';
import { type ListWebhooksQuery, listWebhooksQuery } from 'crm-atoms/queries/webhook/listWebhooks';
import { type CreateWebhookPayload, type WebhookType } from 'crm-atoms/types/webhook';

const webhookService = baseService.injectEndpoints({
  endpoints: (build) => ({
    createWebhook: build.mutation<{
      success: string,
      webhook: WebhookType,
    }, CamelToSnakeCaseKeys<CreateWebhookPayload>>({
      query: (payload) => ({
        method: 'POST',
        url: '/v1/webhooks',
        body: payload,
      }),
    }),
    updateWebhook: build.mutation<{
      success: string,
      webhook: WebhookType,
    }, { id: string | number, payload: CamelToSnakeCaseKeys<CreateWebhookPayload> }>({
      query: ({ id, payload }) => ({
        method: 'PATCH',
        url: `/v1/webhooks/${id}`,
        body: payload,
      }),
    }),
    getWebhook: build.query<void, string | number>({
      query: (id) => ({
        method: 'GET',
        url: `/v1/webhooks/${id}`,
      }),
    }),
    listWebhooks: build.query<ListWebhooksQuery, Array<string | number> | string | number>({
      query: (ids) => ({
        method: 'POST',
        url: '/graphql',
        body: {
          query: listWebhooksQuery,
          variables: {
            ids: Array.isArray(ids) ? ids : [ids],
          },
        },
      }),
      transformResponse: transformGraphqlResponse,
    }),
  }),
});

export const {
  useCreateWebhookMutation,
  useListWebhooksQuery,
  useUpdateWebhookMutation,
} = webhookService;

export default webhookService;
